export default __webpack_public_path__ + "static/media/bg-group-polisport-bycicle.11c31904.png";